module.exports = __webpack_public_path__ + "static/media/globe-stand.9dafb315.svg";